import React from 'react'
import { FormattedMessage } from 'react-intl'

export const BATTLE_ROOMS_CREATE_UNIT_BUTTON_CAPTION = (
    <FormattedMessage
        id='battle_rooms.create_unit_button_caption'
        defaultMessage='Создать отряд'
    />
)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/CreateUnitButton/constants.jsx